const mainFeatureFiltersWrapperDesktop = document.querySelector(".collection-list-main-feature-filter-wrapper-desktop");
const mainFeatureFiltersWrapperMobile = document.querySelector(".collection-list-main-feature-filter-wrapper-mobile");
const mainFeatureActiveFiltersWrapper = document.querySelector(".active-filters-wrapper");
const mainFeatureInactiveFiltersWrapper = document.querySelector(".inactive-filters-wrapper");
const mainFeatureFilters = Array.from(document.querySelectorAll(".main-feature-filter"));
const genderFilterWrapper = document.querySelector(".collection-list-gender-filter-wrapper");
const genderFilters = Array.from(document.querySelectorAll(".gender-filter"));
const templateProductSlide = document.querySelector(".list-collections-product-slide");
const noCollectionMatchingFilterEl = document.querySelector(".no-collection-matching-filters");

const mainFeatureFilterKeyQueryParam = "filter.p.m." + royerApiNamespace + ".main_features";
const genderFilterKeyQueryParam = "filter.p.m." + royerApiNamespace + ".target_gender";

const collectionsProductSwipers = {};

const initialUrl = new URL(window.location);
const initialActiveFilters = initialUrl.searchParams.getAll("filter");
const initialActiveGenderFilters = initialUrl.searchParams.getAll("gender");
//If no gender was selected in the query_params check if there is any currently active in the HTML (in case there is some default values)
if (initialActiveGenderFilters.length == 0) {
  defaultGenderHandles = Array.from(document.querySelectorAll(".gender-filter.active"))?.map(el => el.dataset.handle);
  if (defaultGenderHandles.length != 0){
    initialActiveGenderFilters.push(...defaultGenderHandles);
    initialUrl.searchParams.set("gender", defaultGenderHandles[0]);
    window.history.replaceState(null, "", initialUrl);
  }
}

let totalProductImgsToLoad = 0;
let crtProductImgsLoaded = 0;

const collectionWrappers = Array.from(document.querySelectorAll(".collection-list-wrapper .collection-hero"));
collectionWrappers.forEach(wrapper => {
  const collectionHandle = wrapper.dataset.collectionHandle;
  const collectionInfo = collectionsInformations.find(ci => ci.handle == collectionHandle);
  const filteredProducts = filterProducts(collectionsWithProducts[collectionHandle],initialActiveFilters,initialActiveGenderFilters);
  const filteredOrderedProducts = orderProducts(filteredProducts);

  //Hide the collection if empty or if it has a specified gender and the gender doesn't match the currently selected gender
  if (filteredOrderedProducts.length == 0 || (collectionInfo.mainTargetGender && !initialActiveGenderFilters.includes(collectionInfo.mainTargetGender))) wrapper.classList.add("d-none");
  else wrapper.classList.remove("d-none");

  //Update shop collection button to have the filter query params based on the currently filtered main features
  const shopCollectionBtn = wrapper.querySelector(".shop-collection-button");
  const url = new URL(shopCollectionBtn.href);
  //Remove all previous query params
  url.search = '';
  //Add all the currently active main feature filters to the query params
  initialActiveFilters.forEach(filter => {
    //Technically could be either the mobile or desktop element but in this case we don't care since we just want hte metaobject gid which is the same for both
    const mainFilterEl = mainFeatureFilters.find(mainFeatureFilter => mainFeatureFilter.dataset.handle == filter);
    url.searchParams.append(mainFeatureFilterKeyQueryParam, mainFilterEl.dataset.metaobjectGid);
  });
  initialActiveGenderFilters.forEach(filter => {
    const genderFilterEl = genderFilters.find(genderFilter => genderFilter.dataset.handle == filter);
    url.searchParams.append(genderFilterKeyQueryParam, genderFilterEl.dataset.metaobjectGid);
  });
  shopCollectionBtn.href = url;

  //Add the slides for all the current products to show (don't add any products if the collection isn't shown)
  addProductSlidesToCollection(wrapper.querySelector(".swiper-wrapper"), wrapper.classList.contains("d-none") ? [] : filteredOrderedProducts);

  const collectionSwiperWrapperSelector = ".product-slider-" + collectionHandle;
  
  //Initialize and save the swiper in a variable
  collectionsProductSwipers[collectionHandle] = new Swiper(collectionSwiperWrapperSelector + " .swiper-wrapper-wrapper", {
      // Optional parameters
      direction: "horizontal",
      shortSwipes: true,
      simulateTouch: true,
      slideToClickedSlide: false,
      slidesPerView: "auto",
      slidesPerGroupAuto: true,
      spaceBetween: 8,
      loop: false,
      speed: 500,
      autoHeight: true,
      effect: "slide",
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      allowSlideNext: true,
      allowTouchMove: true,
      // Navigation arrows
      navigation: {
          prevEl: collectionSwiperWrapperSelector + " .slider-back-btn",
          nextEl: collectionSwiperWrapperSelector + " .slider-next-btn",
      },
      on: {
      },
  });
});
//Show no collection matching filter if all collections are hidden
if (collectionWrappers.every(el => el.classList.contains("d-none"))) noCollectionMatchingFilterEl.classList.remove("d-none");
else noCollectionMatchingFilterEl.classList.add("d-none");

//If there was no product image to load then hide the site loader
if (totalProductImgsToLoad == 0) siteLoader.hide();

function productImgLoaded(){
  crtProductImgsLoaded++;
  if (totalProductImgsToLoad == crtProductImgsLoaded && Object.keys(collectionsProductSwipers).length == collectionWrappers.length){
    siteLoader.hide();
  }
}

function genderFilterClicked(e){
  const filterEl = e.target.closest(".gender-filter");
  const handleClicked = filterEl.dataset.handle;
  const isActive = filterEl.classList.contains("active");
  if (!isActive){
    Array.from(genderFilterWrapper.children).forEach(el => el.classList.remove("active"));
    filterEl.classList.add("active");
    const url = new URL(window.location);
    // Add or update the parameter
    url.searchParams.set("gender", handleClicked);
    window.history.replaceState(null, "", url);
    updateCollections();
  }
}

function mainFeatureFilterClicked(e){
  const filterEl = e.target.closest(".main-feature-filter");
  const handleClicked = filterEl.dataset.handle;
  const isActive = filterEl.classList.contains("active");
  const mobileEl = mainFeatureFiltersWrapperMobile.querySelector(`[data-handle='${handleClicked}']`);
  const desktopEl = mainFeatureFiltersWrapperDesktop.querySelector(`[data-handle='${handleClicked}']`);
  const url = new URL(window.location);
  
  if (isActive){
    mobileEl.classList.remove("active");
    desktopEl.classList.remove("active");
    //Move it from the mobile active wrapper to mobile inactive wrapper
    mainFeatureInactiveFiltersWrapper.appendChild(mobileEl);
    
    url.searchParams.delete("filter", handleClicked);
  }
  else{
    mobileEl.classList.add("active");
    desktopEl.classList.add("active");
    //Move it from the mobile inactive wrapper to mobile active wrapper
    mainFeatureActiveFiltersWrapper.appendChild(mobileEl);

    url.searchParams.append("filter", handleClicked);
  }

  //Update query params
  window.history.replaceState(null, "", url);
  
  // Sort mobile active filters based on data-rank
  Array.from(mainFeatureActiveFiltersWrapper.children).sort((a, b) => {
    return Number(a.dataset.rank) - Number(b.dataset.rank); // Sort by data-rank
  })
  .forEach(child => mainFeatureActiveFiltersWrapper.appendChild(child));

  // Sort mobile inactive filters based on data-rank
  Array.from(mainFeatureInactiveFiltersWrapper.children).sort((a, b) => {
    return Number(a.dataset.rank) - Number(b.dataset.rank); // Sort by data-rank
  })
  .forEach(child => mainFeatureInactiveFiltersWrapper.appendChild(child));
  
  // Sort desktop filters based on active status and data-rank
  Array.from(mainFeatureFiltersWrapperDesktop.children).sort((a, b) => {
      const aActive = a.classList.contains("active") ? 0 : 1;
      const bActive = b.classList.contains("active") ? 0 : 1;
      if (aActive !== bActive) return aActive - bActive; // Ensure active elements come first
      else return Number(a.dataset.rank) - Number(b.dataset.rank); // Sort by data-rank
  })
  .forEach(child => mainFeatureFiltersWrapperDesktop.appendChild(child));
  
  updateCollections();
}

function updateCollections(){
  const url = new URL(window.location);
  const activeFilters = url.searchParams.getAll("filter");
  const activeGenderFilters = url.searchParams.getAll("gender");

  collectionWrappers.forEach(wrapper => {
    const collectionHandle = wrapper.dataset.collectionHandle;
    const collectionInfo = collectionsInformations.find(ci => ci.handle == collectionHandle);
    const filteredProducts = filterProducts(collectionsWithProducts[collectionHandle],activeFilters,activeGenderFilters);
    const filteredOrderedProducts = orderProducts(filteredProducts);

    //Hide the collection if empty or if it has a specified gender and the gender doesn't match the currently selected gender
    if (filteredOrderedProducts.length == 0 || (collectionInfo.mainTargetGender && !activeGenderFilters.includes(collectionInfo.mainTargetGender))) wrapper.classList.add("d-none");
    else wrapper.classList.remove("d-none");
    
    const collectionSwiper = collectionsProductSwipers[collectionHandle];
    //Remove old slides
    collectionSwiper.slidesEl.innerHTML = "";
    //Add new slides
    addProductSlidesToCollection(collectionSwiper.slidesEl,filteredOrderedProducts);
    collectionSwiper.updateSlides();

    //Update shop collection button to have the filter query params based on the currently filtered main features
    const shopCollectionBtn = wrapper.querySelector(".shop-collection-button");
    const url = new URL(shopCollectionBtn.href);
    //Remove all previous query params
    url.search = '';
    //Add all the currently active main feature filters to the query params
    activeFilters.forEach(filter => {
      //Technically could be either the mobile or desktop element but in this case we don't care since we just want hte metaobject gid which is the same for both
      const mainFilterEl = mainFeatureFilters.find(mainFeatureFilter => mainFeatureFilter.dataset.handle == filter);
      url.searchParams.append(mainFeatureFilterKeyQueryParam, mainFilterEl.dataset.metaobjectGid);
    });
    activeGenderFilters.forEach(filter => {
      const genderFilterEl = genderFilters.find(genderFilter => genderFilter.dataset.handle == filter);
      url.searchParams.append(genderFilterKeyQueryParam, genderFilterEl.dataset.metaobjectGid);
    });
    shopCollectionBtn.href = url;
  });

  //Show no collection matching filter if all collections are hidden
  if (collectionWrappers.every(el => el.classList.contains("d-none"))) noCollectionMatchingFilterEl.classList.remove("d-none");
  else noCollectionMatchingFilterEl.classList.add("d-none");
}

function filterProducts(products, activeFilters, activeGenderFilters){  
  return products.filter(product => (activeGenderFilters.length == 0 || activeGenderFilters.includes(product.targetGender)) && (activeFilters.length == 0 || activeFilters.every(filter => product.mainFeatures.includes(filter)) ))
}

function orderProducts(products){
  return products.sort((a, b) => a.score - b.score)
}

function addProductSlidesToCollection(swiperEl, products){
  //Reversing because we want the first product to appear first and we are appending the slides at the end of the parent
  products.reverse().forEach(product => {
    const newSlide = templateProductSlide.cloneNode(true);
    
    const link = newSlide.querySelector(".product-slide-link");
    link.href = product.url;
    
    const img = newSlide.querySelector(".product-slide-img");
    img.src = baseCdnPath + product.mainImgUrl + "?width=" + img.width + "&height=" + img.height;
    img.alt = product.mainImgAlt;
    img.addEventListener("load", () => productImgLoaded())
    img.addEventListener("error", () => productImgLoaded())
    totalProductImgsToLoad++;
    
    swiperEl.appendChild(newSlide);
  });
}